///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.multiselect.d.ts"/>
import { Component, OnInit } from "@angular/core";
import { Constants } from "../Services/Constants";
import { HTTPService } from "../Services/http.service";
import { Observable } from "rxjs/Observable";
import { filter } from "../App/search.pipe";
import { DatePipe } from "@angular/common";
import { MySharedService } from "../App/shared.service";
import { FormControl } from "@angular/forms";
import {Cookie} from "ng2-cookies/ng2-cookies";

declare function ExportToExcel(
  item: any[],
  workSheetName: string,
  keys: any,
  Columns?: any,
): void;
@Component({
  templateUrl: "./AppViews/Users/users.html",
})
export class UsersComponent implements OnInit {
  userDetail: any;
  public constants: Constants;
  public users: any[] = [];
  public reportUsers: any[] = [];
  public roles: any[] = [];
  public newRoles: any[] = [];
  public teams: any[] = [];
  public projects: any[] = [];
  public vendorItems: any[] = [];
  public shiftItems: any[] = [];
  public siteItems: any[] = [];
  public userStatus: any[] = [];
  public usersTeamAssigned: any = [];
  public editusersTeamAssigned: any = [];
  public editusersProjectAssigned: any = [];
  public usersFiltered: any = [];
  public timeZone: any[] = [];
  public GradeList: any[] = [];
  public filterUsersRole: any = "";
  public filterUserStatus: any = "";
  public filterUsersSite: any = "";
  public filterUsersTeam: any = "";
  public Search: any = "";
  public shiftInTime: any = "";
  public shiftOutTime: any = "";
  public addUserData: any = {
    addUserRole: "",
    addUserTeamID: "",
    VendorId: "",
    SiteId: "",
    ShiftId: "",
    addUserIsActive: "",
    addUserIsOnLeave: false,
    UserTypeId: 1,
    TimeZoneId: "",
    addGradeId: "",
    addUserCurrency: "",
    addUserCost: 0,
    ProjectIds: "",
    CustomerId: "",
  };
  public editUserData: any = {
    editUserRole: "",
    editUserTeamID: "",
    VendorId: "",
    SiteId: "",
    ShiftId: "",
    editUserIsActive: "",
    editUserIsOnLeave: false,
    UserTypeId: 1,
    TimeZoneId: "",
    addGradeId: "",
    editUserCurrency: "",
    editCost: 0,
    ProjectIds: "",
    CustomerId: "",
  };
  public isAdd: boolean = true;
  public loginNameAlreadyExists: boolean = false;
  public codeAlreadyExists: boolean = false;
  public emailAlreadyExists: boolean = false;
  public reportToSelf: boolean = false;
  public reviewedBySelf: boolean = false;
  public newReportList: any[] = [];
  public currencies: any = [];
  active = true;
  public showLoader = false;
  public isFormSubmitted: boolean = false;
  flag = true;
  projectflag = true;
  control: FormControl;
  configurationlist: any;
  configurationarray: any = [];
  projectList: any = [];
  customers: any = [];

  constructor(
    private _httpService: HTTPService,
    private _sharedService: MySharedService,
  ) {
    this.constants = new Constants();
    this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    this.filterUserStatus = this.constants.enumUserStatus["Active"];
    this.filterUsersTeam = "";
  }

  public getResourceGrade() {
    this._httpService
      .ajaxPost("Common/GetGrade", {
        GradeId: 0,
        TeamId: this.userDetail.TeamID,
      })
      .subscribe((data) => {
        this.GradeList = data["GradeList"];
      });
  }
  // public GetConfiguration() {

  //     this._httpService.ajaxPost('Common/GetConfiguration', { })
  //         .subscribe(data => {
  //             this.configurationlist= data['Configurationlist'];
  //             this.configurationarray = this.configurationlist.split(',');
  //             this.configurationarray.forEach(element => {
  //                 $( "#"+element ).prop( "disabled", true );
  //             });

  //         });
  // }

  getProjects(prm) {
    // this.newForm();
    // $('#teamProjectSelectid').empty().append('<option selected="selected" value="test">White</option>');
    //this.ClearAddForm();
    this.projectList = [];
    this._httpService
      .ajaxPost("Project/GetProjectListbyTeam", {
        OwnerTeamId: prm.toString(),
      })
      .subscribe(
        (data) => {
          this.projectList = data["ProjectList"];
          setTimeout(function () {
            $("#teamProjectSelectid").multiselect("rebuild");
            $("#editeamProjectSelect").multiselect("rebuild");
          }, 100);
        },
        (err) => {
          this.projectList = [];
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },

        () => {
          this.showLoader = false;
        },
      );
  }
  changeTeam() {
    this.usersTeamAssigned = "";
    this.editusersTeamAssigned = "";
    this.editusersProjectAssigned = "";
    this.getProjects("");
    this.Reinitiate();

    // var selectedValues = new Array();

    // $("#editroleteamSelect").val(selectedValues);
    // $("#editusersTeamAssigned").val(selectedValues);
    // $("#roleteamSelectid").val(selectedValues);
    // $("#usersTeamAssigned").val(selectedValues);

    // $("#editroleteamSelect").multiselect('refresh');
    // $("#roleteamSelectid").multiselect('refresh');
  }

  newForm() {
    var scope = this;
    this.usersTeamAssigned = "";
    this.editusersTeamAssigned = "";
    this.editusersProjectAssigned = "";
    this.active = false;
    setTimeout(() => (this.active = true), 0);
    setTimeout(() => $(".report_userlist").selectpicker(), 0);
    setTimeout(() => {
      $("#roleteamSelectid").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });

      $("#roleteamSelectid option").each(function () {
        if ($(this).attr("selected") == "selected") {
        }
      });
    }, 0);

    setTimeout(() => {
      $("#roleteamSelectid").change(function () {
        var selectOption = $(this).find(":selected");
        var selectedValues = new Array();
        selectOption.each(function (e) {
          selectedValues.push($(this).val());
        });
        $("#roleteamSelectid").val(selectedValues);
        $("#usersTeamAssigned").val(selectedValues);

        scope.projectList = [];
        scope.getProjects(selectedValues);
      });

      if (scope.projectList.length > 0) {
        $("#teamProjectSelectid").multiselect({
          enableFiltering: false,
          includeSelectAllOption: true,
          selectAllJustVisible: false,
          numberDisplayed: 1,
        });
      }
    }, 1000);
  }

  Reinitiate() {
    var scope = this;
    setTimeout(() => {
      $("#roleteamSelectid").change(function () {
        var selectOption = $(this).find(":selected");
        var selectedValues = new Array();
        selectOption.each(function (e) {
          selectedValues.push($(this).val());
        });
        $("#roleteamSelectid").val(selectedValues);
        $("#usersTeamAssigned").val(selectedValues);
        scope.projectList = [];
        scope.getProjects(selectedValues);
      });

      if (scope.projectList.length > 0) {
        $("#teamProjectSelectid").multiselect({
          enableFiltering: false,
          includeSelectAllOption: true,
          selectAllJustVisible: false,
          numberDisplayed: 1,
        });
      }
    }, 1000);
  }

  public EditMultiSelect(id) {
    var scope = this;

    setTimeout(() => {
      $("#editroleteamSelect").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });

      $("#editroleteamSelect option").each(function () {
        if ($(this).attr("selected") == "selected") {
        }
      });
      if (this.userDetail.SiteUserId == this.editUserData.SiteUser_Id) {
        $("#editroleteamSelect").multiselect("disable");
      }
    }, 0);

    setTimeout(() => {
      $("#teamProjectSelectid").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });

      $("#teamProjectSelectid option").each(function () {
        if ($(this).attr("selected") == "selected") {
        }
      });
      if (this.userDetail.SiteUserId == this.editUserData.SiteUser_Id) {
        $("#teamProjectSelectid").multiselect("disable");
      }
    }, 0);

    setTimeout(() => {
      $("#editroleteamSelect").change(function () {
        var selectOption = $(this).find(":selected");
        var selectedValues = new Array();
        selectOption.each(function (e) {
          selectedValues.push($(this).val());
        });

        $("#editroleteamSelect").val(selectedValues);
        $("#editusersTeamAssigned").val(selectedValues);

        scope.projectList = [];
        scope.getProjects(selectedValues);
      });
    }, 500);
  }

  public addmultiSelect() {}

  ngOnInit() {
    this.getRole();
    this.getStatus();
    this.getTeam();
    this.getProject();
    this.getUsers();
    this.getVendor();
    this.getShift();
    this.getSite();

    this.getReportedUsers();
    this.getResourceGrade();
    this.getCurrency();
    this.getProjects("");
    this.getTimeZone();
    this.getCustomer();
    // $('.date').datetimepicker({
    //     format: 'DD/MM/YYYY'
    // });
  }

  ngAfterViewInit() {
    var scope = this;

    $("#editUser").on("hidden.bs.modal", function () {
      scope.CancelEditUserNew();
    });

    $("#show-filter").click(function () {
      $(".filter-form").slideToggle();
    });

    $(".date").datetimepicker({
      format: "DD/MM/YYYY",
    });

    // $('#DOB').datetimepicker({
    //     format: 'DD/MM/YYYY'
    // });
    setTimeout(() => {
      $("#roleteamSelectid").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });

      $("#roleteamSelectid option").each(function () {
        if ($(this).attr("selected") == "selected") {
        }
      });
    }, 1000);

    $("#roleteamSelectid").change(function () {
      var selectOption = $(this).find(":selected");
      var selectedValues = new Array();
      selectOption.each(function (e) {
        selectedValues.push($(this).val());
      });

      $("#roleteamSelectid").val(selectedValues);
      $("#usersTeamAssigned").val(selectedValues);
      scope.projectList = [];
      scope.getProjects(selectedValues);

      $("#teamProjectSelectid option").each(function () {
        $(this).html($(this).html().replace(/\s+/g, " "));
      });
    });

    setTimeout(() => {
      $("#editroleteamSelect").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });

      $("#editroleteamSelect option").each(function () {
        if ($(this).attr("selected") == "selected") {
        }
      });
    }, 1001);

    setTimeout(() => {
      $("#editeamProjectSelect").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });

      $("#editeamProjectSelect option").each(function () {
        if ($(this).attr("selected") == "selected") {
        }
      });
    }, 1001);

    $("#editroleteamSelect").change(function () {
      var selectOption = $(this).find(":selected");
      var selectedValues = new Array();
      selectOption.each(function (e) {
        selectedValues.push($(this).val());
      });

      scope.projectList = [];
      scope.getProjects(selectedValues);
      $("#editroleteamSelect").val(selectedValues);
      $("#editusersTeamAssigned").val(selectedValues);
    });

    $("#editeamProjectSelect").change(function () {
      var selectOption = $(this).find(":selected");
      var selectedValues = new Array();
      selectOption.each(function (e) {
        selectedValues.push($(this).val());
      });

      $("#editeamProjectSelect").val(selectedValues);
      //$("#editusersTeamAssigned").val(selectedValues);
    });

    setTimeout(() => {
      $("#teamProjectSelectid").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });

      $("#teamProjectSelectid option").each(function () {
        if ($(this).attr("selected") == "selected") {
        }
      });
    }, 1001);

    $("#teamProjectSelectid").change(function () {
      var selectOption = $(this).find(":selected");
      var selectedValues = new Array();
      selectOption.each(function (e) {
        selectedValues.push($(this).val());
      });

      $("#teamProjectSelectid").val(selectedValues);
      $("#editusersProjectAssigned").val(selectedValues);
    });

    // $('#editUser').bind('hide', function () {
    //     scope.CancelEditUser();
    //   });
  }

  ngAfterViewChecked() {
    var scope = this;
    if (this.reportUsers.length > 0) {
      $(".report_userlist").selectpicker({
        style: "btn-info",
        size: 4,
      });
    }

    if (this.teams.length > 0) {
      $("#roleteamSelectid").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });
    }
    if (this.teams.length > 0) {
      $("#editroleteamSelect").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });
    }
    if (scope.projectList.length > 0) {
      $("#teamProjectSelectid").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });
    }

    if (scope.projectList.length > 0) {
      $("#editeamProjectSelect").multiselect({
        enableFiltering: false,
        includeSelectAllOption: true,
        selectAllJustVisible: false,
        numberDisplayed: 1,
      });
    }

    $("#roleteamSelectid option").each(function () {
      $(this).html($(this).html().replace(/\s+/g, " "));
    });
    $("#editroleteamSelect option").each(function () {
      $(this).html($(this).html().replace(/\s+/g, " "));
    });

    $("#teamProjectSelectid option").each(function () {
      $(this).html($(this).html().replace(/\s+/g, " "));
    });

    $("#editeamProjectSelect option").each(function () {
      $(this).html($(this).html().replace(/\s+/g, " "));
    });

    // setTimeout(() => {
    $(".date").datetimepicker({
      format: "DD/MM/YYYY",
    });
    // }, 0);
  }
  setTeamProject() {
    this.getProjects(this.usersTeamAssigned);
    //alert(this.usersTeamAssigned);
  }
  setTeamProjectedit() {
    // alert($('#editUserTeamId').val());
    this.getProjects($("#editUserTeamId").val());
    //alert(this.usersTeamAssigned);
  }
  public ResetForm(form: any) {
    form.reset();
    form.resetForm();
    this.isFormSubmitted = false;
    this.flag = true;
    this.projectflag = true;
  }

  public getRole() {
    this._httpService.ajaxPost("Common/GetRole", null).subscribe((data) => {
      this.roles = data["Roles"];
      this.roles.forEach((element) => {
        if (element.Name != "HRAdmin") {
          this.newRoles.push(element);
        }
      });
    });
  }

  public getStatus() {
    this._httpService
      .ajaxPost("Common/GetParameter", {
        ParameterTypeId: this.constants.enumParamterTypeName["UserStatus"],
      })
      .subscribe((data) => {
        this.userStatus = data["Parameter"];
      });
  }

  public getTeam() {
    this._httpService
      .ajaxPost("Team/GetAssignedTeam", {
        TeamId: this.userDetail.TeamID,
        UserId: this.userDetail.SiteUserId,
      })
      .subscribe((data) => {
        this.teams = data["AssignedTeam"];
      });
  }

  public getProject() {
    this._httpService.ajaxPost("Common/GetProjects", null).subscribe((data) => {
      this.projects = data["Projects"];
    });
  }

  public getVendor() {
    this._httpService.ajaxPost("Common/GetVendor", null).subscribe((data) => {
      this.vendorItems = data["Vendor"];
    });
  }

  public getShift() {
    this._httpService.ajaxPost("Common/GetShift", null).subscribe((data) => {
      this.shiftItems = data["Shift"];
    });
  }
  public getSite() {
    this._httpService.ajaxPost("Common/GetSite", null).subscribe((data) => {
      this.siteItems = data["Site"];
    });
  }

  public getTimeZone() {
    this._httpService.ajaxPost("Common/GetTimeZone", null).subscribe((data) => {
      this.timeZone = data["TimeZone"];
    });
  }

  public getUsers() {
    var TeamId = "";
    if (this.filterUsersTeam == "") {
      TeamId = this.userDetail.TeamID;
    } else {
      TeamId = this.filterUsersTeam;
    }
    this.showLoader = true;
    this._httpService
      .ajaxPost("Users/GetUsersList", {
        IsActive: this.filterUserStatus,
        Role: this.filterUsersRole,
        Site: this.filterUsersSite,
        Team: TeamId,
        UserId: this.userDetail.SiteUserId,
      })
      .subscribe(
        (data) => {
          this.users = data["Users"];
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },

        () => {
          this.showLoader = false;
        },
      );
  }

  public getCustomer() {
    this.showLoader = true;
    this._httpService
      .ajaxPost("Customer/GetCustomer", {
        CustomerId: 0,
        CountryId: 0,
        CustomerStatus: true,
      })
      .subscribe(
        (data) => {
          this.customers = data["CustomerList"];
          this.customers.sort(function (a, b) {
            if (a.Customer_Name.toLowerCase() < b.Customer_Name.toLowerCase())
              return -1;
            if (a.Customer_Name.toLowerCase() > b.Customer_Name.toLowerCase())
              return 1;
            return 0;
          });
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },

        () => {
          this.showLoader = false;
        },
      );
  }

  public getReportedUsers() {
    this._httpService
      .ajaxPost("Users/GetUsersList", {
        IsActive: 1,
        Team: this.userDetail.TeamID,
        UserId: this.userDetail.SiteUserId,
      })
      .subscribe((data) => {
        this.reportUsers = data["Users"];
        this.reportUsers.forEach((element) => {
          if (element.Role == 1 || element.Role == 2) {
            this.newReportList.push(element);
          }
        });

        setTimeout(function () {
          $(".report_userlist").selectpicker("refresh");
        }, 1000);
      });
  }

  public clearFilter() {
    this.filterUsersRole = "";
    this.filterUserStatus = this.constants.enumUserStatus["Active"];
    this.Search = "";
    this.filterUsersSite = "";
    this.filterUsersTeam = "";
  }

  ClearAddForm() {
    $("#btnAddUserForm").trigger("click");
    this.addUserData = {
      addUserRole: "",
      addUserTeamID: "",
      VendorId: "",
      SiteId: "",
      ShiftId: "",
      addUserIsActive: true,
      addUserIsOnLeave: false,
      UserTypeId: 1,
      TimeZoneId: "",
      addUserReportTo: "",
      addGradeId: "",
      addUserCurrency: "",
      addUserCost: 0,
      ProjectIds: "",
      CustomerId: "",
    };
    this.newForm();
    this.isAdd = true;
    setTimeout(function () {
      $("option:selected").removeAttr("selected");
      $("#roleteamSelectid").multiselect("refresh");
      //   $("#teamProjectSelectid").multiselect('refresh');
      $("#teamProjectSelectid").val(null).trigger("change");
    }, 0);
  }

  public CancelAddUser() {
    this.addUserData = {
      addUserRole: "",
      addUserTeamID: "",
      VendorId: "",
      SiteId: "",
      ShiftId: "",
      addUserIsActive: "",
      addUserIsOnLeave: false,
      UserTypeId: 1,
      TimeZoneId: "",
      addUserReportTo: "",
      addGradeId: "",
      addUserCurrency: "",
      addUserCost: 0,
      ProjectIds: "",
      CustomerId: "",
    };
    this.usersTeamAssigned = "";
    this.newForm();
    $("#addUser").modal("hide");
    this.isAdd = true;
    this.loginNameAlreadyExists = false;
    this.codeAlreadyExists = false;
    this.emailAlreadyExists = false;
  }

  public CancelEditUser() {
    this.editUserData = {
      editUserRole: "",
      editUserTeamID: "",
      VendorId: "",
      SiteId: "",
      ShiftId: "",
      editUserIsActive: "",
      editUserIsOnLeave: false,
      UserTypeId: 1,
      TimeZoneId: "",
      editUserReportTo: "",
      editUserReviewed_By: "",
      editGradeId: "",
      CustomerId: "",
    };
    this.newForm();
    $("#editUser").modal("hide");
    this.isAdd = true;
    this.loginNameAlreadyExists = false;
    this.codeAlreadyExists = false;
    this.emailAlreadyExists = false;
    this.reportToSelf = false;
    this.reviewedBySelf = false;
  }

  public CancelEditUserNew() {
    this.editUserData = {
      editUserRole: "",
      editUserTeamID: "",
      VendorId: "",
      SiteId: "",
      ShiftId: "",
      editUserIsActive: "",
      editUserIsOnLeave: false,
      UserTypeId: 1,
      TimeZoneId: "",
      editUserReportTo: "",
      editUserReviewed_By: "",
      editGradeId: "",
      CustomerId: "",
    };
    this.newForm();
    this.isAdd = true;
    this.loginNameAlreadyExists = false;
    this.codeAlreadyExists = false;
    this.emailAlreadyExists = false;
    this.reportToSelf = false;
    this.reviewedBySelf = false;
  }

  public AddUser(form: any) {
    this.isFormSubmitted = true;
    if (form.form.valid) {
      this.loginNameAlreadyExists = false;
      this.codeAlreadyExists = false;
      this.emailAlreadyExists = false;
      this.users.forEach((element) => {
        if (element.Username == this.addUserData.addUserUsername) {
          this.loginNameAlreadyExists = true;
        }
        if (element.Emp_Code == this.addUserData.addEmpCode) {
          this.codeAlreadyExists = true;
        }
        if (element.Email_Id == this.addUserData.addUserEmailId) {
          this.emailAlreadyExists = true;
        }
      });
      if (
        !this.loginNameAlreadyExists &&
        !this.codeAlreadyExists &&
        !this.emailAlreadyExists
      ) {
        let objItem: any = {};
        if (
          this.addUserData.addUserRole != 3 &&
          this.addUserData.UserTypeId == 1
        ) {
          let myDiv = document.getElementById("usersTeamAssigned");
          this.usersTeamAssigned = myDiv["value"];
        }
        objItem.SiteUser_Id = 0;
        objItem.UserTypeId = this.addUserData.UserTypeId;
        objItem.Name = this.addUserData.addUserName;
        objItem.Role = this.addUserData.addUserRole;
        objItem.Username = this.addUserData.addUserUsername;
        objItem.Password = this.addUserData.addUserPassword;
        objItem.Email_Id = this.addUserData.addUserEmailId;
        objItem.Emp_Code = this.addUserData.addEmpCode;
        objItem.TeamID =
          this.addUserData.UserTypeId == 1
            ? this.addUserData.addUserTeamID
            : this.addUserData.VendorId;
        objItem.SiteId = this.addUserData.SiteId;
        objItem.ShiftId = this.addUserData.ShiftId;
        objItem.TimeZoneId = this.addUserData.TimeZoneId;
        objItem.GradeId = this.addUserData.addGradeId;
        objItem.Is_Active = this.addUserData.addUserIsActive;
        objItem.IsOnLeave = this.addUserData.addUserIsOnLeave;
        objItem.Report_To = this.addUserData.addUserReportTo;
        objItem.UserList =
          this.addUserData.UserTypeId == 1 ? this.usersTeamAssigned : "";
        objItem.CustomerId =
          this.addUserData.UserTypeId == 3 ? this.addUserData.CustomerId : "";

        if (
          $("#teamProjectSelectid") != null &&
          $("#teamProjectSelectid") != undefined &&
          $("#teamProjectSelectid").val() != null &&
          $("#teamProjectSelectid").val() != undefined
        )
          objItem.ProjectIds = $("#teamProjectSelectid").val().toString();
        // if (this.addUserData.DOB != null) {
        objItem.Dob = this.addUserData.DateOfBirth;
        objItem.HourlyRate =
          this.addUserData.addUserCost == "" ? 0 : this.addUserData.addUserCost;
        objItem.Currency =
          this.addUserData.addUserCurrency == null ||
          this.addUserData.addUserCurrency == ""
            ? 0
            : this.addUserData.addUserCurrency;
        this.flag = true;
        this.projectflag = true;
        if (
          this.addUserData.editUserRole != 3 &&
          this.addUserData.UserTypeId == 1 &&
          objItem.UserList == ""
        ) {
          this.flag = false;
        }
        if (
          objItem.ProjectIds == null ||
          objItem.ProjectIds == "" ||
          objItem.ProjectIds == undefined
        )
          this.projectflag = false;
        //&&  this.projectflag==true
        if (this.flag == true) {
          this.addEditUser(objItem);
          $("#addUser").modal("hide");
          this.addUserData = {};
          this.isAdd = true;
        }
      }
    }
    if (this.addUserData.addUserRole != 3 && this.addUserData.UserTypeId == 1) {
      let myDiv = document.getElementById("usersTeamAssigned");
      this.usersTeamAssigned = myDiv["value"];
      if (this.usersTeamAssigned == "") {
        this.flag = false;
      } else {
        this.flag = true;
      }
      var ProjectIdsSelected = "";
      if (
        $("#teamProjectSelectid") != null &&
        $("#teamProjectSelectid") != undefined &&
        $("#teamProjectSelectid").val() != null &&
        $("#teamProjectSelectid").val() != undefined
      )
        ProjectIdsSelected = $("#teamProjectSelectid").val().toString();
      if (ProjectIdsSelected == "") {
        this.projectflag = false;
      } else {
        this.projectflag = true;
      }
    }
  }

  public UpdateUser(form: any) {
    this.isFormSubmitted = true;
    if (form.form.valid) {
      this.loginNameAlreadyExists = false;
      this.codeAlreadyExists = false;
      this.emailAlreadyExists = false;
      this.reportToSelf = false;
      this.reviewedBySelf = false;
      this.users.forEach((element) => {
        if (
          element.SiteUser_Id != this.editUserData.SiteUser_Id &&
          element.Username == this.editUserData.editUserUsername
        ) {
          this.loginNameAlreadyExists = true;
        }
        if (
          element.SiteUser_Id != this.editUserData.SiteUser_Id &&
          element.Emp_Code == this.editUserData.editEmpCode
        ) {
          this.codeAlreadyExists = true;
        }
        if (
          element.SiteUser_Id != this.editUserData.SiteUser_Id &&
          element.Email_Id == this.editUserData.editUserEmailId
        ) {
          this.emailAlreadyExists = true;
        }
      });

      if (this.editUserData.editUserReportTo == this.editUserData.SiteUser_Id) {
        this.reportToSelf = true;
      } else if (
        this.editUserData.editUserReviewed_By == this.editUserData.SiteUser_Id
      ) {
        this.reviewedBySelf = true;
      } else {
        if (
          !this.loginNameAlreadyExists &&
          !this.codeAlreadyExists &&
          !this.emailAlreadyExists
        ) {
          let objItem: any = {};
          if (
            this.editUserData.editUserRole != 3 &&
            this.editUserData.UserTypeId == 1
          ) {
            let myDiv = document.getElementById("editusersTeamAssigned");
            this.editusersTeamAssigned = myDiv["value"];
          }
          // let myProjectDiv = document.getElementById('editusersProjectAssigned');
          //     this.editusersProjectAssigned = myProjectDiv["value"];

          objItem.SiteUser_Id = this.editUserData.SiteUser_Id;
          objItem.UserTypeId = this.editUserData.UserTypeId;
          objItem.Name = this.editUserData.editUserName;
          objItem.Role = this.editUserData.editUserRole;
          objItem.Username = this.editUserData.editUserUsername;
          objItem.Password = this.editUserData.editUserPassword;
          objItem.Email_Id = this.editUserData.editUserEmailId;
          objItem.Emp_Code = this.editUserData.editEmpCode;
          objItem.TeamID =
            this.editUserData.UserTypeId == 1
              ? this.editUserData.editUserTeamID
              : this.editUserData.VendorId;
          objItem.SiteId = this.editUserData.SiteId;
          objItem.ShiftId = this.editUserData.ShiftId;
          objItem.TimeZoneId = this.editUserData.TimeZoneId;
          objItem.GradeId = this.editUserData.editGradeId;
          objItem.Is_Active = this.editUserData.editUserIsActive;
          objItem.IsOnLeave = this.editUserData.editUserIsOnLeave;
          objItem.Report_To = this.editUserData.editUserReportTo;
          objItem.Reviewed_By = this.editUserData.editUserReviewed_By;
          objItem.UserList =
            this.editUserData.UserTypeId == 1 ? this.editusersTeamAssigned : "";
          objItem.Dob = this.editUserData.Dob;
          objItem.HourlyRate =
            this.editUserData.editCost == "" ? 0 : this.editUserData.editCost;
          objItem.Currency =
            this.editUserData.editUserCurrency == null ||
            this.editUserData.editUserCurrency == ""
              ? 0
              : this.editUserData.editUserCurrency;
          objItem.CustomerId = this.editUserData.CustomerId;

          if (
            $("#editeamProjectSelect") != null &&
            $("#editeamProjectSelect") != undefined &&
            $("#editeamProjectSelect").val() != null &&
            $("#editeamProjectSelect").val() != undefined
          )
            objItem.ProjectIds = $("#editeamProjectSelect").val().toString();
          // objItem.ProjectIds =this.editUserData.ProjectIds;
          this.flag = true;
          // if (this.editUserData.editUserRole != 3 && this.editUserData.UserTypeId == 1 && objItem.UserList == "") {
          //     this.flag = false;
          // }
          this.projectflag = true;
          if (
            objItem.ProjectIds == null ||
            objItem.ProjectIds == "" ||
            objItem.ProjectIds == undefined
          )
            this.projectflag = false;
          // && this.projectflag==true
          if (this.flag == true) {
            this.addEditUser(objItem);
            $("#editUser").modal("hide");
            this.editUserData = {};
            this.isAdd = true;
          }
        }
      }
    }
  }

  addEditUser(objItem) {
    objItem.Created_By = this.userDetail.SiteUserId;
    objItem.Modified_By = this.userDetail.SiteUserId;
    this._httpService
      .ajaxPost("Users/AddUpdateUsers", objItem)
      .subscribe((data) => {
        this._sharedService.ShowMessage(data["Status"].Message);
        this.getUsers();
      });
  }

  public EditUsers(item: any) {
    $("#btnEditUserForm").trigger("click");
    this.isAdd = false;
    this.EditUserChange(item.SiteUser_Id);
    setTimeout(() => $(".report_userlist").selectpicker(), 500);
    setTimeout(() => {
      ($("#editroleteamSelect").multiselect("refresh"),
        $("#editeamProjectSelect").multiselect("refresh"));
    }, 500);
  }

  public EditUserChange(itemId) {
    let objItem: any = {};
    objItem = JSON.parse(
      JSON.stringify(
        this.users.filter((user) => user.SiteUser_Id == itemId)[0],
      ),
    );

    this.editUserData.SiteUser_Id = objItem.SiteUser_Id;
    this.editUserData.UserTypeId = objItem.UserTypeId;
    this.editUserData.editUserName = objItem.Name;
    this.editUserData.editUserRole = objItem.Role;
    this.editUserData.editUserUsername = objItem.Username;
    this.editUserData.editUserPassword = objItem.Password;
    this.editUserData.editUserEmailId = objItem.Email_Id;
    this.editUserData.editEmpCode = objItem.Emp_Code;
    if (objItem.UserTypeId == 1) {
      this.editUserData.editUserTeamID = objItem.TeamID;
    }
    if (objItem.UserTypeId == 2) {
      this.editUserData.VendorId = objItem.VendorId;
    }
    this.editUserData.ProjectIds = objItem.ProjectIds;
    if (objItem.UserTypeId == 3) {
      this.editUserData.CustomerId = objItem.CustomerId;
    }

    let ids: string[] = [];
    if (
      this.editUserData.UserTypeId == 1 &&
      this.editUserData.ProjectIds != null &&
      this.editUserData.ProjectIds != ""
    ) {
      this.getProjects(objItem.TeamID);
      var proIds = this.editUserData.ProjectIds.split(",");

      proIds.forEach((element) => {
        if (element != "") ids.push(element);
      });
    }

    this.editUserData.SiteId = objItem.SiteId;
    this.editUserData.ShiftId = objItem.ShiftId;
    this.editUserData.TimeZoneId = objItem.TimeOffsetID;
    this.editUserData.editGradeId = objItem.GradeId;
    this.editUserData.editUserData = objItem.editUserData;
    this.editUserData.editUserIsActive = objItem.Is_Active;
    this.editUserData.editUserIsOnLeave = objItem.IsOnLeave;
    this.editUserData.editUserReportTo = objItem.Report_To;
    this.editUserData.Dob = objItem.DateOfBirth;
    this.editUserData.editCost = objItem.HourlyRate;
    this.editUserData.editUserCurrency = objItem.CurrencyId;
    this.editUserData.editUserReviewed_By = objItem.Reviewed_By;

    // this.GetConfiguration();
    setTimeout(function () {
      $(".report_userlist").selectpicker("refresh");
    }, 0);
    if (this.editUserData.UserTypeId == 1) {
      this.getProjects(objItem.TeamID);
      var TeamListArray = new Array();
      if (this.users != undefined) {
        this.users.forEach((element) => {
          if (itemId == element.SiteUser_Id) {
            if (element.TeamID != "") {
              TeamListArray = element.TeamID.split(",");
            }
          }
        });
      }
      //this.getProjects( objItem.TeamID);
      this.editusersTeamAssigned = [];
      this.teams.forEach((element) => {
        element.Selected = false;
        if (TeamListArray.length > 0) {
          TeamListArray.forEach((item) => {
            if (item == element.Team_Id) {
              element.Selected = true;
              var length = this.editusersTeamAssigned.length;
              this.editusersTeamAssigned[length] = element.Team_Id;
            }
          });
        }
      });
      //$("#editroleteamSelect").val(this.editusersTeamAssigned);
      $("#editroleteamSelect").val(this.editusersTeamAssigned);
      this.editusersTeamAssigned = objItem.TeamID;
    } else {
      this.editUserData.VendorId = objItem.VendorId;
      this.editusersTeamAssigned = "";
    }

    var TeamListArray = new Array();
    if (this.users != undefined) {
      this.users.forEach((element) => {
        if (itemId == element.SiteUser_Id) {
          if (element.TeamID != "") {
            TeamListArray = element.TeamID.split(",");
          }
        }
      });
    }

    this.editusersProjectAssigned = [];
    this.teams.forEach((element) => {
      element.Selected = false;
      if (TeamListArray.length > 0) {
        TeamListArray.forEach((item) => {
          if (item == element.ProjectIds) {
            element.Selected = true;
            var length = this.editusersProjectAssigned.length;
            this.editusersProjectAssigned[length] = element.ProjectIds;
          }
        });
      }
    });
    this.editusersProjectAssigned = objItem.ProjectIds;

    // setTimeout(function () {
    //     console.log('inside Assignment');
    //    // console.log(ids);
    //     $('#editeamProjectSelect').multiselect('rebuild');
    //     $("#editeamProjectSelect").val(ids);
    //    // console.log( $("#editeamProjectSelect").val());

    // }, 500);
    setTimeout(() => {
      $("#editeamProjectSelect").multiselect("rebuild");
      $("#editeamProjectSelect").val(ids);
    }, 2000);

    //$("#editusersProjectAssigned").val(this.editusersProjectAssigned);
    //$("#editeamProjectSelect").val(ids);
    //   console.log('Reached b4 assignment');
    // setTimeout(function(){
    //     //alert(ids);
    //     console.log('inside Assignment');
    //    $("#editeamProjectSelect").val(ids);
    //    console.log('Assignment Completed');//alert($("#editeamProjectSelect").val());
    //    $('#editeamProjectSelect').multiselect('rebuild');
    //    //$("#editeamProjectSelect").val(ids).trigger('change')
    //      ;},500);

    setTimeout(function () {
      $("#editroleteamSelect").multiselect("refresh");
      $("#editeamProjectSelect").multiselect("refresh");
    }, 0);
    console.log(ids);
    setTimeout(() => {
      $("#editeamProjectSelect").multiselect("rebuild");
    }, 4000);
    console.log($("#editeamProjectSelect").val());
    if (
      (ids != null &&
        ids != undefined &&
        $("#editeamProjectSelect").val() == null) ||
      $("#editeamProjectSelect").val() == ""
    )
      this.rebindProject(ids);
  }

  rebindProject(prm) {
    console.log("last query cal ");
    setTimeout(() => {
      $("#editeamProjectSelect").val(prm);
      $("#editeamProjectSelect").multiselect("rebuild");
    }, 2000);
  }

  test(id) {}

  ExportUsers() {
    var fil = new filter();
    var ExportList;
    ExportList = JSON.parse(JSON.stringify(this.users));
    ExportList = fil.transform(ExportList, this.Search);
    for (var i = 0; i < ExportList.length; i++) {
      var element = ExportList[i];
      element.TimeZone = element.Location + "(" + element.TimeOffset + ")";
      element.Shift =
        element.ShiftName +
        "(" +
        element.shiftInTime +
        "-" +
        element.shiftOutTime +
        ")";
      if (element.IsOnLeave) {
        element.onLeave = "Yes";
      } else {
        element.onLeave = "No";
      }

      if (element.Is_Active) {
        element.IsActive = "Active";
      } else {
        element.IsActive = "Inactive";
      }
    }
    ExportToExcel(
      ExportList,
      "Users",
      [
        "Emp_Code",
        "Name",
        "RoleName",
        "Username",
        "Email_Id",
        "ManagerName",
        "TeamName",
        "SiteName",
        "TimeZone",
        "GradeName",
        "Shift",
        "IsActive",
        "onLeave",
        "UserTypeName",
      ],
      [
        "Employee Code",
        "Employee Name",
        "Employee Role",
        "Username",
        "Email Id",
        "Manager Name",
        "Team Name",
        "Site Name",
        "Time Zone",
        "GradeName",
        "Shift",
        "Is Active",
        "On Leave",
        "User Type",
      ],
    );
  }

  public getCurrency() {
    this.showLoader = true;
    this._httpService
      .ajaxPost("Common/GetParameter", {
        ParameterTypeId: this.constants.enumParamterTypeName["Currency"],
      })
      .subscribe(
        (data) => {
          this.currencies = data["Parameter"];
          console.log(this.currencies);
        },
        (err) => {
          this.showLoader = false;
        },
        () => {
          this.showLoader = false;
        },
      );
  }

  isEditMode() {
    return this.editUserData != null && this.editUserData.SiteUser_Id > 0;
  }

  centralLoginCheck(): boolean {
    if (!this._httpService.isCentralLogin) return false;
    return Cookie.get("centralLogin") && Cookie.get("centralLogin") === "true";
  }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/Users/users.component.ts
 **/